import Delta from "quill-delta";
import { DEFAULT_FONT_FAMILY } from "@/fonts/constants";
import { DEFAULT_FONT_SIZE } from "../constantsV2";
import type { TextV2Data } from "../typesV2";

export function createDefaultTextData(): TextV2Data {
    return {
        fontFamily: DEFAULT_FONT_FAMILY,
        fontSize: DEFAULT_FONT_SIZE,
        textAlign: "left",
        textVerticalAlign: "center",
        delta: new Delta(),
    };
}
